import {
  isRequired,
  isNumber,
  isEmail,
  isPhoneNumber,
  type Validation,
} from './utils';

const validations: Validation[] = [
  ({ wholesaleName }) => isRequired(wholesaleName) || { wholesaleName: 'website name is required.' },
  ({ wholesalePhone }) => isPhoneNumber(wholesalePhone, true) || { wholesalePhone: 'wholesale phone is required and should be valid.' },
  ({ wholesaleEmail }) => isEmail(wholesaleEmail, true) || { wholesaleEmail: 'wholesale email is required and should be valid.' },
  ({ senderEmail }) => isEmail(senderEmail, false) || { senderEmail: 'sender email should be valid.' },
  // ({ senderName }) => false || { senderName: 'senderName should be valid.' },
  ({ emailSendThreshold }) => isNumber(emailSendThreshold) || { emailSendThreshold: 'order update waiting time should be valid.' },
  ({ shippingWindowInWeeks }) => isNumber(shippingWindowInWeeks) || { shippingWindowInWeeks: 'shipping window should be valid.' },
  ({ shippingReminderThresholdDays }) => isNumber(shippingReminderThresholdDays) || { shippingReminderThresholdDays: 'shipping reminder threshold should be valid.' },
  ({ wearDateBufferDays }) => (isNumber(wearDateBufferDays) && Number.isInteger(Number(wearDateBufferDays)) && Number(wearDateBufferDays) >= 0)
    || { wearDateBufferDays: 'wear date buffer should be a whole number of days, 0 or more.' },
  ({ customizationConfirmDays }) => (isNumber(customizationConfirmDays) && Number.isInteger(Number(customizationConfirmDays))
    && Number(customizationConfirmDays) >= 1 && Number(customizationConfirmDays) <= 60)
    || { customizationConfirmDays: 'customization confirmation window should be a whole number of days between 1 and 60.' },
  ({ announcement: _announcement }) => true,
];

const KEYS = [
  'wholesaleName',
  'wholesalePhone',
  'wholesaleEmail',
  'senderEmail',
  'emailSendThreshold',
  'shippingWindowInWeeks',
  'shippingReminderThresholdDays',
  'wearDateBufferDays',
  'customizationConfirmDays',
];

export {
  validations,
  KEYS,
};
